if (!window.jd1QuantityInitialized) {
  window.jd1QuantityInitialized = true;

  document.addEventListener('click', function (event) {
    const plus = event.target.closest('[data-jd1-bb-plus]');
    const minus = event.target.closest('[data-jd1-bb-minus]');

    if (!plus && !minus) return;

    const qty = event.target.closest('[data-jd1-bb-qty]');
    if (!qty) return;

    const input = qty.querySelector('[data-jd1-bb-input]');
    if (!input) return;

    event.preventDefault();

    if (plus) {
      input.stepUp();
    }

    if (minus) {
      input.stepDown();
    }

    input.dispatchEvent(new Event('input', {
      bubbles: true
    }));

    input.dispatchEvent(new Event('change', {
      bubbles: true
    }));
  });
}